module.exports = __webpack_public_path__ + "d0582cd9082bce989b78c49641033cb0.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/guardian.png
// module id = 602
// module chunks = 0